import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { youtubeData } from 'src/components/template/compare/components/data/youtubeData'

export default (props) => <CompareTemplate location={props.location} data={youtubeData} />
